<template>
  <!-- <sidebar-item :link="{ name: 'Email Templates', path: '/settings/email-templates' }" v-if="_gAuth.isAppSas() &&  _gHlp.checkAccess(['role_admin', 'role_corporate', 'role_super_admin'])"></sidebar-item> -->
	<div>
    <base-header class="pb-0">
				<b-row align-v="center" class="py-1">
						<b-col cols="12">
								<h2 class="listing-title d-inline-block mb-0">Template Setting</h2>
						</b-col>
						<b-col cols="12" class="text-right ">
							<el-tabs v-model="current_tab">
								<el-tab-pane label="SMS Template" name="smsTemplate">
									<router-link slot="label" :to="'/settings/sms-templates'" class="text-dark">SMS Template</router-link>
								</el-tab-pane>
								<el-tab-pane label="Email Templates" name="emailTemplate">
									<router-link slot="label" :to="'/settings/email-templates'" class="text-dark">Email Templates</router-link>
								</el-tab-pane>
							</el-tabs>
						</b-col>
				</b-row>
		</base-header>
	</div>	
</template>

<script>
import { Tabs, TabPane } from 'element-ui'

export default {
		props: ['tab_name'],
    components: {
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            modals:{
                create_new: false,
                update_status: false,
            },
            backButton: false,
						current_tab: this.tab_name
        };
    },
    methods: {
			handleTabClick(obj, e) {
				
      }
    }
}
</script>